<!--设备电子围栏到车辆-->
<template>
    <el-dialog :title="$t('arealimitset.setareavehicles')" :visible.sync="dialogVisible" width="50%">
      <div>
        <div style="display: flex; align-items: center">
          <span
            style="flex: 1; font-size: 12px; font-weight: bold; color: #0f1a3a"
            >{{$t('carlineBinding.vehiclelist')}}</span
          >
          <div>
            <el-form
              @submit.native.prevent
              :size="size"
              :model="form"
              label-width="0"
            >
              <el-form-item label="">
                <el-input
                  prefix-icon="el-icon-search"
                  clearable
                  :size="size"
                  v-model="form.CarNo"
                  :placeholder="$t('vehicle.carNoPls')"
                  @change="queryList"
                > <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="queryList"
                ></el-button
              >
            </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div>
          <el-table
            v-loading="loading"
            size="mini"
            :data="dataList"
            border
            highlight-current-row
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
  
            <el-table-column prop="CarNo" align="center" :label="$t('vehicle.carNo')">
            </el-table-column>
            <el-table-column prop="DeviceNo" align="center" :label="$t('vehicle.DeviceNo')">
            </el-table-column>
            <el-table-column prop="ManufactureID" align="center" :label="$t('vehicle.ManufactureNo')">
            </el-table-column>
            <el-table-column
              prop="UpdateTime"
              v-if="form.QueryFlag == 1"
              align="center"
              :label="$t('arealimitset.bindtime')"
            >
            </el-table-column>
          </el-table>
  
          <kl-pagination
            :total="total"
            @current-change="pageChange"
            :current-page.sync="form.PageNo"
          >
          </kl-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogVisible = false">{{$t('public.cancel')}}</el-button>
        <el-button
          type="primary"
          v-if="form.QueryFlag == 2"
          :size="size"
          @click="saveConfig"
          >{{$t('arealimitset.bindvehicle')}}</el-button
        >
        <el-button
          type="primary"
          v-if="form.QueryFlag == 1"
          :size="size"
          @click="saveConfig"
          >{{$t('arealimitset.unbindvehicle')}}</el-button
        >
      </span>
    </el-dialog>
  </template>
  <script>
  export default {
    props: {},
    data() {
      return {
        dialogVisible: false,
        total: 0,
        loading: false,
        dataList: [],
        form: {
          OperatorID: 0,
          AreaID: 0,
          AreaType: 0,
          CarNo: "",
          DeviceNo: "",
          QueryFlag: 2,
          PageNo: 1,
          PageSize: 10,
        },
        multipleSelection: [],
        deleteId: [],
      };
    },
    computed: {
      size() {
        return this.$store.getters.size;
      },
      operator() {
        return this.$store.getters.operator;
      },
     
    },
    methods: {
      saveConfig() {
        var ids = "";
  
        ids = this.deleteId.join(",");
  
        if (this.deleteId.length == 0) {
          //提示，请选择车辆
          this.$message({
            type: "error",
            message:this.$t('hightlimit.selectVehicle'),
          });
          return;
        }
   
        this.$confirm(
          this.form.QueryFlag == 1
            ? this.$t('arealimitset.delBind')
            :  this.$t('arealimitset.addBind') ,
            this.$t('public.tips') ,
          {
            confirmButtonText: this.$t('public.confirm')  ,
            cancelButtonText: this.$t('public.cancel') ,
            type: "warning",
          }
        ).then(() => {
          this.$api
            .bindVehicleAndOverSpeedRemindArea({
              OperatorID: this.operator.OperatorId,
              VehicleIDs: ids.toString(),
              AreaID: this.form.AreaID,
              Flag: this.form.QueryFlag == 2 ? 1 : 0,
              AreaType: this.form.AreaType,
            })
            .then((res) => {
              console.log(res);
              //成功提示
              this.$message({
                type: "success",
                message:
                  this.$t('arealimitset.msgissend'),
              });
              this.queryList();
              this.dialogVisible = false;
            })
            .catch(() => {
              //失败提示
              this.$message({
                type: "error",
                message: this.$t('public.SetFail') ,
              });
            });
        });
  
        //提交接口保存
      },
      handleSelectionChange(selection) {
        this.multipleSelection = selection;
        console.log(selection);
        this.deleteId = selection.map((item) => item.VehicleID);
        console.log(this.deleteId);
      },
      bind(row, QueryFlag) {
        //
        this.form.AreaType = row.AreaType;
        this.form.AreaID = row.AreaID;
        this.form.QueryFlag = QueryFlag;
  
        this.queryList();
        this.dialogVisible = true;
      },
      pageChange(page) {
        this.form.PageNo = page;
  
        this.queryList();
      },
      queryList() {
        this.loading = true;
        this.dataList = [];
        this.form.OperatorID = this.operator.OperatorId;
  
        this.$api
          .queryOverSpeedRemindVehicleInfo(this.form)
          .then((res) => {
            this.loading = false;
            if (res && res.code == 200) {
              //本地分页
              this.dataList = res.data;
  
              this.total = res.count;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
    },
    mounted() {},
  };
  </script>
  